import "./AyurvedaFooter.css";
import logo from '../images/6_Ayur copy.webp'
import { FaPhone } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import ScrollToTop from "../ScrollToTop";
import WhatsAppButton from "../WhatsAppButton";
import qr from '../images/qr_code.webp';
import { MdOutlineMail } from "react-icons/md";
import { Link } from "react-router-dom";
import { AiFillInstagram } from "react-icons/ai";

export default function AyurvedaFooter() {
  return (
    <footer className="ayf-footer  pb-5 " style={{backgroundColor:'#f7f0d3'}}>
      
      <div className="container-fluid py-5">
        <div className="row gy-3">

          {/* About */}
          <div className="col-lg-3 col-md-6" style={{paddingLeft:'2%',}}>
            <img src={logo} alt=".." style={{width:'200px',height:'100px'}}/><br/>
            <p className="ayf-text para-font justify-text">
             Ayur Moksha is an ideal platform to help you rediscover and embrace the lifestyle you deserve for a healthier, more balanced tomorrow. Through personalized lifestyle guidance rooted in traditional  Ayurvedic principles, we help you establish daily routines that support physical vitality, mental clarity, and emotional stability. This guidance gently removes stress patterns and mental blocks, allowing a natural sense of balance and well-being to emerge.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h4 className="head-font">Quick Links</h4><br/>
            <ul className="ayf-links para-font">
              <li><Link to="/" className="para-font" >Home</Link></li>
              <li><Link to="/ourstory" className="para-font">About</Link></li>
              <li><Link to="/treatment" className="para-font">Treatments</Link></li>
              <li><Link to="/contact" className="para-font">Contact us</Link></li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div className="col-lg-2 col-md-6">
            <h4 className="head-font">Opening Hours</h4><br/>
            <ul className="ayf-hours">
               <li><span className="para-font" style={{color:'#059302'}}>Monday</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-10 AM – 5 PM</li>
              <li><span className="para-font" style={{color:'#059302'}} >Tuesday</span>&nbsp;&nbsp;  &nbsp;&nbsp; &nbsp;-10 AM  – 5 PM</li>
              <li><span className="para-font" style={{color:'#059302'}}>Wednesday</span>&nbsp;-10 AM – 5 PM</li>
              <li><span className="para-font" style={{color:'#059302'}}>Thursday</span> &nbsp; &nbsp;&nbsp;-10 AM – 5 PM</li>
              <li><span className="para-font" style={{color:'#059302'}}>Friday</span> &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  -10 AM – 5 PM</li>
              <li><span className="para-font" style={{color:'#059302'}}>Saturday</span> &nbsp;&nbsp;&nbsp;&nbsp;-10 AM – 5 PM</li>
              <li><span className="para-font" style={{color:'#059302'}}>Sunday</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-10 AM – 3 PM</li>
           
            </ul>
          </div>
           {/* Opening Hours */}
          <div className="col-lg-2 col-md-6">
            <h4 className="head-font">Treatments</h4><br/>
            <ul className="ayf-hours">
              <li className="para-font"><Link to="/postNatal" className="text-decoration-none text-white">Postnatal Care</Link></li>
              <li className="para-font"><Link to="/rejuvenation" className="text-decoration-none text-white">Rejuvenation Therapy</Link></li>
              <li className="para-font"><Link to="/hair_treatment" className="text-decoration-none text-white">Hair Treatment</Link></li>
              <li className="para-font"><Link to="/lifestyle_yoga" className="text-decoration-none text-white">Life Style Guidence & Yoga</Link></li>
              <li className="para-font"><Link to="/soundarya_kalpa" className="text-decoration-none text-white">Soundarya Kalpa</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-lg-3 col-md-6">
            <h4 className="head-font">Connect Us</h4><br/>
            {/* <ul className="ayf-contact para-font">
              <li><FaLocationDot style={{fontSize:'15px',color:'#059302'}}/>&nbsp;Door No.108 B,Ruby Road, Karuvanthuruthy, &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Feroke 673631, Kozhikode, Kerala 673631</li>
              <li><MdOutlineMail  style={{fontSize:'15px',color:'#059302'}} />&nbsp;ayurmokshacalicut@gmail.com</li>
              <li><FaPhone  style={{fontSize:'15px',color:'#059302'}}/>&nbsp;+91 7736 111 482</li>
              <li><AiFillInstagram  style={{fontSize:'15px',color:'#059302'}}/>&nbsp;<Link to="https://www.instagram.com/ayur.moksha?igsh=MTU0NWI1N2x5dnNkag==" className="text-white text-decoration-none">ayur.moksha</Link></li>
            
            </ul> */}
            <ul className="ayf-contact para-font">

  {/* LOCATION */}
  <li className="ayf-contact-row">
    <span className="ayf-contact-icon">
      <FaLocationDot />
    </span>
    <span className="ayf-contact-text">
      Door No.108 B, Ruby Road, Karuvanthuruthy,  
      Feroke 673631, Kozhikode, Kerala 673631
    </span>
  </li>

  {/* EMAIL */}
  <li className="ayf-contact-row">
    <span className="ayf-contact-icon">
      <MdOutlineMail />
    </span>
    <span className="ayf-contact-text">
      ayurmokshacalicut@gmail.com
    </span>
  </li>

  {/* PHONE */}
  <li className="ayf-contact-row">
    <span className="ayf-contact-icon">
      <FaPhone />
    </span>
    <span className="ayf-contact-text">
      +91 7736 111 482
    </span>
  </li>

  {/* INSTAGRAM */}
  <li className="ayf-contact-row">
    <span className="ayf-contact-icon">
      <AiFillInstagram />
    </span>
    <span className="ayf-contact-text">
      <Link
        to="https://www.instagram.com/ayur.moksha"
        target="_blank"
        className="text-white text-decoration-none"
      >
        ayur.moksha
      </Link>
    </span>
  </li>

</ul>

            <img src={qr} alt="qr" height={100} width={100} style={{marginLeft:'20px'}}/><br/><br/>
            <Link to="/terms_condition" className="text-white text-decoration-none">*Terms&Conditions</Link><br/>

          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="ayf-bottom">
        <p>© zonemacsolutions 2025 | All Rights Reserved</p>
      </div>
      <ScrollToTop/>
      <WhatsAppButton />
    </footer>
  );
}
